import { render, staticRenderFns } from "./EditLogin.vue?vue&type=template&id=4dc9be46"
import script from "./EditLogin.vue?vue&type=script&lang=js"
export * from "./EditLogin.vue?vue&type=script&lang=js"
import style0 from "./EditLogin.vue?vue&type=style&index=0&id=4dc9be46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports